// Package Imports
import { useState, useEffect } from "react"

// Internal Imports
import { IResendOTP } from "../../../types";
import { resendOTP } from "../services/AuthActions";
import { message } from "antd";
import mixpanelService from "../services/mixpanel";

export const useResendOTP = ({ username, clientID }: IResendOTP) => {
  const [shouldInvoke, setShouldInvoke] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isError, setIsError] = useState<Error | null>(null);
  const [isData, setIsData] = useState<string | null>(null);

  // SIDE-EFFECT - Re-Send OTP
  useEffect(() => {
    // CHECK - Re-send State
    if (!shouldInvoke) return;

    const processResendOTP = async () => {
      try {
        setIsLoading(true);

        const resendOTPResult = await resendOTP({ username, clientID });

        // CHECK - Re-send OTP Result
        if (resendOTPResult === null) throw new Error("Unable to re-send OTP");

        mixpanelService.track("App.Resend.OTP", {username: username});

        // CHECK - Re-send OTP Result [Success]
        if (resendOTPResult.successMessage) {
          message.success(resendOTPResult.successMessage, 5);
          setIsData(resendOTPResult.successMessage);
        }

        // CHECK - Re-send OTP Result [Failure]
        if (resendOTPResult.errorMessage) {
          message.error(resendOTPResult.errorMessage, 10);
          setIsData(resendOTPResult.errorMessage);
        }

        setShouldInvoke(false);
        setIsLoading(false);
      } catch (err) {
        setShouldInvoke(false);
        setIsLoading(false);
        setIsError(err);
      }
    };

    processResendOTP();
  }, [shouldInvoke, username, clientID]);

  return {
    resendOTPLoading: isLoading,
    resendOTPError: isError,
    resendOTPData: isData,
    invokeResendOTP: () => setShouldInvoke(true)
  }
}
